export default "__VITE_ASSET__DmtCOhoF__"